import type {
  PublishOperatorDocument,
  DocumentStatus,
} from 'src/apis/document-exchange/types';
import { type StatusProps } from 'src/components/data-display/status-display';
import type { DocumentFormValues } from 'src/pages/shippers/documents/upload-documents/schema';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const transformData = ({
  adminsOnly,
  allShippers,
  title,
  type,
  file,
  selectedShippers,
  description,
}: DocumentFormValues): {
  data: PublishOperatorDocument;
} => ({
  data: {
    documentName: title,
    documentType: type,
    documentDescription: description ?? undefined,
    privilegedUsersOnly: adminsOnly,
    fileId: file.id,
    recipients: allShippers
      ? []
      : selectedShippers.length
        ? selectedShippers.map(({ value }) => value)
        : undefined,
  },
});

export const documentStatusLabels: Record<DocumentStatus, string> = {
  WITHDRAWN: 'Withdrawn',
  PUBLISHED: 'Published',
};

export const documentStatusOptions = labelsToOptions(documentStatusLabels);

export const documentStatusValues = labelsToValues(documentStatusLabels);

export const variantMap: Record<DocumentStatus, StatusProps['variant']> = {
  WITHDRAWN: 'inactive',
  PUBLISHED: 'success',
};
